// IOSentra brand mark — the OFFICIAL approved icon (broken circular ring + ECG
// pulse + endpoint dot) built from the brand kit's exact SVG paths + gradient
// (vertical, teal #00D4C3 → blue #0866FF). Inline SVG so it scales crisply at any
// size and needs no asset pipeline. Keep in sync with apps/cloud-admin/src/IOSentraLogo.tsx.
export function IOSentraLogo({ size = 32, className }: { size?: number; className?: string }) {
  // Unique gradient id per size so multiple logos on a page don't collide.
  const gid = `iosentraGrad-${size}`;
  return (
    <svg width={size} height={size} viewBox="0 0 256 256" fill="none" className={className} role="img" aria-label="IOSentra">
      <defs>
        <linearGradient id={gid} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#00D4C3" />
          <stop offset="100%" stopColor="#0866FF" />
        </linearGradient>
      </defs>
      <path d="M194 82 A86 86 0 1 0 194 174" fill="none" stroke={`url(#${gid})`} strokeWidth="15" strokeLinecap="butt" />
      <path
        d="M31 128 L88 128 L103 82 L122 174 L145 112 L159 128 L211 128"
        fill="none" stroke={`url(#${gid})`} strokeWidth="11" strokeLinecap="round" strokeLinejoin="round"
      />
      <circle cx="214" cy="128" r="10" fill={`url(#${gid})`} />
    </svg>
  );
}
